var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9905 10.6964C19.9905 9.83608 19.9224 9.20824 19.7752 8.55716H10.1992V12.4404H15.8201C15.7068 13.4054 15.0948 14.8588 13.7349 15.8353L13.7159 15.9653L16.7436 18.3718L16.9534 18.3933C18.8798 16.5679 19.9905 13.8821 19.9905 10.6964Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 20.9278C12.953 20.9278 15.2648 19.9977 16.9534 18.3932L13.7349 15.8353C12.8737 16.4516 11.7177 16.8817 10.1992 16.8817C7.50211 16.8817 5.21297 15.0564 4.39695 12.5334L4.27734 12.5439L1.12906 15.0436L1.08789 15.161C2.76508 18.5792 6.21016 20.9278 10.1992 20.9278Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39695 12.5334C4.18164 11.8824 4.05703 11.1847 4.05703 10.4639C4.05703 9.74301 4.18164 9.04544 4.38562 8.39436L4.37992 8.2557L1.19219 5.71582L1.08789 5.76672C0.396641 7.18518 0 8.77805 0 10.4639C0 12.1498 0.396641 13.7425 1.08789 15.161L4.39695 12.5334Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 4.04603C12.1144 4.04603 13.4062 4.89476 14.1429 5.60403L17.0213 2.72062C15.2535 1.03477 12.953 0 10.1992 0C6.21016 0 2.76508 2.34855 1.08789 5.76674L4.38563 8.39439C5.21297 5.87142 7.50211 4.04603 10.1992 4.04603Z",
    fill: "#EB4335"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.6c15d673.svg";
export { ForwardRef as ReactComponent };